<template>
    <div class="register">
      <!-- 我的学费 -->
     <div>
        <h3 style="text-align: center;font-weight:bold;font-size:16px;margin-top:50px;">学费汇总</h3>
        <a-table
         style="padding:10px;"
         :columns="columns"
         :data-source="dataSource"
        >
            <template slot="payStatus" slot-scope="text,record">
              <span v-if="record.payStatus===1">已缴费</span>
              <span v-if="record.payStatus===0">未缴费</span>
            </template>

            <template slot="approveStatus" slot-scope="text,record">
              <span v-if="record.approveStatus===1">通过</span>
              <span v-if="record.approveStatus===2">拒绝</span>
              <span v-if="record.approveStatus===0">未审核</span>
            </template>

            <template slot="action" slot-scope="text,record">
                <a-button v-if="record.payStatus === 0&&record.sendStatus === 0" @click="uploadPaymentVoucher(record)">上传缴费凭证</a-button>
                <a-button v-else @click="lookPaymentVoucher(record)">查看缴费凭证</a-button>
            </template>
        </a-table>
     </div>
     <a-modal :width="600" title="缴费凭证" :visible="payVoucherVisible" @cancel="handleClose" @ok="submitVoucher" okText="提交">
        <paymentVoucherUpload ref="uploadFile" :checkFlag="true" @submitVoucher="submitVoucher"/>
    </a-modal>

      <a-modal :width="600" title="缴费凭证" :visible="lookImgVisible" :footer=null @cancel="closeLook">
        <a-carousel arrows style="padding:0px 10px 20px;">
           
            <div  v-for='(item,index) in fileListImg' :key='index'>
              <div>
                 <p style="text-align: center;">{{item.docName}}</p>
                <img :src='item.docUrl' alt=''>
              </div>
            </div>

            <div
              slot="prevArrow"
              slot-scope="props"
              class="custom-slick-arrow"
              style="left: 25px;z-index: 1;"
            >
              <!-- <a-icon type="left-circle" style="font-size:40px;" /> -->
              上一张
            </div>
            <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: -10px">
              <!-- <a-icon type="right-circle" style="font-size:40px;" /> -->
              下一张
            </div>
          </a-carousel>
      </a-modal>
    </div>
  </template>
  
  <script>
import paymentVoucherUpload from '@/pages/documentDetail/components/paymentVoucherUpload.vue'
  export default {
    components: {
        paymentVoucherUpload
    },
    name: "myPersonalStudyFee",
    created() {
    //   this.getDoc();
    },
    data() {
      return {
        dataSource:[],
        columns:[
            {
            align: 'center',
            title: '序号',
            customRender: (text,record,index) => `${index+1}`
            },
            {
                align: 'center',
                title: '学年',
                dataIndex: 'layoutYear'
            },
            {
                align: 'center',
                title: '学费标准',
                dataIndex: 'fee'
            },
            {
                align: 'center',
                title: '已缴学费',
                dataIndex: 'paidFee'
            },
            {
                align: 'center',
                title: '缴费状态',
                dataIndex: 'payStatus',
                scopedSlots:{customRender:'payStatus'}
            },
            {
                align: 'center',
                title: '审核状态',
                dataIndex: 'approveStatus',
                scopedSlots:{customRender:'approveStatus'}
            },
            {
                align: 'center',
                title: '审核意见',
                dataIndex: 'approveMessage'
            },
            {
                align: 'center',
                title: '操作',
                dataIndex: 'action',
                scopedSlots:{customRender:'action'}
            },
        ],
        payVoucherVisible:false,
        paymentId:'',
        lookImgVisible:false,
        fileListImg:[],
        uuid:'',
        type:''
      };
    },
    created(){
    if(this.$route.query.token){
      this.uuid = this.$route.query.token
      this.type = '0'
      this.getTuitionFee(this.uuid,this.type)
      
      return 
    }else if(localStorage.getItem('token')){
      this.uuid = localStorage.getItem('token')
      this.type='1'
      this.getTuitionFee(this.uuid,this.type)
      
      return
    }else{
      this.$message.error('验证失败请重新登录！')
      this.$router.push('/login')
      return
    }
        
    },
    methods: {
      closeLook(){
        this.lookImgVisible = false
      },

      lookPaymentVoucher(record){

        this.axios.get(`/stu/stuUnpaid/mysend?id=`+record.id+'&uuid='+this.uuid+'&type='+this.type).then(res=>{
          if(res.code===200){
            this.fileListImg = res.result
            this.lookImgVisible = true
          }
        })
       
      },

      getTuitionFee(uuid,type){
        this.axios.get(`/stu/stuUnpaid/detail?uuid=`+uuid+'&type='+type,).then(res=>{
            if(res.code === 200){
                this.dataSource = res.result
            }
        })
      },

      uploadPaymentVoucher(record){
        this.paymentId = record.id
        this.payVoucherVisible = true
      },

      submitVoucher(){
        let url = ''
        url = this.$refs.uploadFile.beginUpload()
        url = url.map(res=>res.response.result)
        if(url.length===0){
          this.$message.error('请先选择文件')
          return 
        }
        const params = {}
        params.id = this.paymentId
        params.uuid = this.uuid
        params.type = this.type
        params.urls = url.join(',')
        this.axios.post(`/stu/stuUnpaid/send`,params).then(item=>{
          if(item.code === 200){
            this.$message.success(item.result)
            this.handleClose()
            this.getTuitionFee(this.uuid,this.type)
          }

        })
      },

      handleClose(){
        this.payVoucherVisible = false
        this.$refs.uploadFile.clearUpload()
        this.paymentId = ''
      },
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  @import '~styles/varibles.styl';
  @import '~styles/mixins.styl';
  
  .register {
    margin-left: 20px;
    margin-right: 20px;
  }
  
  .table {
    border-right: 1px solid #f2f2f2;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 0;
  }
  
  .table th {
    font-size: 15px;
    background: $bgcontent;
    font-weight: normal;
    border-left: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2;
    vertical-align: center;
    color: #888;
  }
  
  .toptitle {
    text-align: center;
    font-size: 24px;
    font-weight: bold !important;
    line-height: 44px;
    color: #333 !important;
  }
  
  .sign {
    input {
      background: none;
      border: none;
    }
  
    .col-md-1 {
      padding-right: 0;
    }
  }
  
  .btn {
    background: $bgColor;
    color: #fff;
    width: 120px;
    margin: 20px;
  }
  
  .btn-text {
    color: #c4c4c4;
  }

  .ant-carousel >>> .custom-slick-arrow {
    width: 100px;
    height: 25px;
    font-size: 16px;
    margin:210px 0 0 20px;
    color: #000;
    /*background-color: rgba(31, 45, 61, 0.9);*/
    opacity: 0.8;
  }
  .ant-carousel >>> .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
  }
  
  .ant-carousel >>> .slick-slide h3 {
    color: #fff;
  }
  .ant-carousel >>> .slick-slide img {
    /*width: 50%;*/
    width: 100%;
    height: 360px;
    margin: auto;
    cursor: pointer;
  }
  .ant-carousel >>> .slick-dots-bottom{
    /*color: #000;*/
    bottom: -10px;
  }
  .ant-carousel >>> .slick-dots li{
    background: #000;
  }
  .ant-carousel >>> .slick-dots li.slick-active button{
    background: #999999;
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/myPersonalStudyFee.vue